/** @format */
import { useBaseConfigStoreWithOut } from '../config';
import type { FieldsType, Container, WidgetCPTType } from '../types';

/**
 * @param  {FieldsType[]} widgetDatas 结构数据
 * @param  {Record<string,string>} defaultValue? 默认值
 */
export const getDefaultValue = (
	widgetDatas: FieldsType[],
	defaultValue: Record<string, string> = {},
	dontShowDefaultValues: WidgetCPTType[] = ['subTable'],
) => {
	const defaultValues = defaultValue || {};
	widgetDatas.forEach((itm) => {
		if (itm.pcProps.defaultValue) defaultValues[itm.pcProps.code!] = itm.pcProps.defaultValue;
		if (itm.category === 'container' && itm.children.length && !dontShowDefaultValues?.includes(itm.type)) {
			getDefaultValue(itm.children, defaultValues);
		}
	});
	return defaultValues;
};

/**
 * @param  {FieldsType[]} data 结构数据
 * @param  {(item:FieldsType)=>boolean} filterFun 过滤函数
 */
export const getWidgetItem = (data: FieldsType[], filterFun: (item: FieldsType) => boolean) => {
	let idx = -1;
	let obj: FieldsType | null = null;
	while (++idx < data.length) {
		if (filterFun(data[idx])) {
			obj = data[idx];
			break;
		} else if ((data[idx] as Container).children) {
			const item = getWidgetItem((data[idx] as Container).children, filterFun);
			if (item) {
				obj = item;
				break;
			}
		}
		continue;
	}
	return obj;
};

export const transWidgetDatasPcProps = (widgetDatas: FieldsType[], defaultPcPropsList: Record<string, any>) => {
	return widgetDatas.map((itm) => {
		if (itm.category === 'container') {
			return {
				...itm,
				pcProps: { ...(defaultPcPropsList[itm.type] || {}), ...itm.pcProps },
				children: transWidgetDatasPcProps(itm.children || [], defaultPcPropsList),
			};
		} else {
			return {
				...itm,
				pcProps: { ...(defaultPcPropsList[itm.type] || {}), ...itm.pcProps },
			};
		}
	});
};

export const transWidgetDatas = (widgetDatas: FieldsType[], name?: string) => {
	const baseConfigStore = useBaseConfigStoreWithOut(name);
	const fieldList = baseConfigStore.FIELDS.reduce((obj, item) => {
		item.children.forEach((itm) => {
			obj[itm.type] = itm.pcProps;
		});
		return obj;
	}, {});
	return transWidgetDatasPcProps(widgetDatas, fieldList);
};
